import React from 'react';
import Icon, { IconProps } from '../Icon';

const CloseIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.575684"
          y="14.2175"
          width="20"
          height="1"
          rx="0.5"
          transform="rotate(-45 0.575684 14.2175)"
          fill="currentColor"
        />
        <rect
          x="0.707031"
          width="20"
          height="1"
          rx="0.5"
          transform="rotate(45 0.707031 0)"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};

export default CloseIcon;
